import { Component, Input, OnDestroy } from '@angular/core';
import { ClassNames } from '../../../constants/class-names.constants';
import { Color } from '../../../constants/color.constants';
import { Icons } from '../../../constants/icons.constants';
import { SearchToggleService } from '../../../services/search-toggle.service';
import { forLifeOf, LifecycleAware } from '../../../utilities/rxjs.helpers';

/**
 * @export
 * @class LsqBannerSearchComponent
 * @implements {OnInit}
 * @property {string=} placeholder The placeholder for the search input
 */
@LifecycleAware()
@Component({
    selector: 'lsq-banner-search',
    template: `
        <div
            class="search"
            [ngClass]="{ open: isOpen, closing: closing }"
            (click)="handleClick($event)"
        >
            <div class="search-container">
                <div class="search-form">
                    <div class="search-form-addon-left">
                        <lsq-icon
                            [type]="icons.FaMagnifyingGlassSolid"
                            [color]="color.GraphicGray"
                        ></lsq-icon>
                    </div>
                    <input type="text" [placeholder]="placeholder" class="search-form-input" />
                    <div class="search-form-addon-right" (click)="toggleSearch()">
                        <lsq-icon [type]="icons.CloseSmall" [color]="color.GrayDarkest"></lsq-icon>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class LsqBannerSearchComponent implements OnDestroy {
    @Input() public placeholder = 'Search...';
    public isOpen = false;
    public closing?: boolean;
    public icons = Icons;
    public color = Color;

    constructor(private service: SearchToggleService) {
        this.service.toggleOpen.pipe(forLifeOf(this)).subscribe(() => {
            this.closing = this.isOpen;
            this.isOpen = !this.isOpen;
            if (this.closing) {
                setTimeout(() => {
                    this.closing = null;
                }, 1000);
            }
        });
    }

    public ngOnDestroy(): void {}

    public handleClick(event: any): void {
        const classList = `${ClassNames.Search} ${ClassNames.Open}`;
        if (event.target.getAttribute('class') === classList) {
            this.toggleSearch();
        }
    }

    public toggleSearch(): void {
        this.service.toggleOpen.next();
    }
}
